import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { format, addWeeks, startOfWeek, subWeeks } from "date-fns";

interface WeekNavigatorProps {
  weekStart: Date;
  onChange: (date: Date) => void;
}

export function WeekNavigator({ weekStart, onChange }: WeekNavigatorProps) {
  const weekEnd = addWeeks(weekStart, 1);
  weekEnd.setDate(weekEnd.getDate() - 1);

  const goToPreviousWeek = () => {
    onChange(subWeeks(weekStart, 1));
  };

  const goToNextWeek = () => {
    onChange(addWeeks(weekStart, 1));
  };

  const goToCurrentWeek = () => {
    onChange(startOfWeek(new Date(), { weekStartsOn: 1 }));
  };

  return (
    <div className="flex items-center gap-4">
      <Button variant="outline" size="icon" onClick={goToPreviousWeek}>
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <div className="text-center min-w-[200px]">
        <p className="font-medium">
          {format(weekStart, "MMM d")} - {format(weekEnd, "MMM d, yyyy")}
        </p>
        <p className="text-sm text-gray-500">
          Week of {format(weekStart, "MMMM d")}
        </p>
      </div>
      <Button variant="outline" size="icon" onClick={goToNextWeek}>
        <ChevronRight className="h-4 w-4" />
      </Button>
      <Button variant="ghost" size="sm" onClick={goToCurrentWeek}>
        Today
      </Button>
    </div>
  );
}
